import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
} from '@angular/router';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { INavBar } from './Components/navbar/navbar.model';
import { SYSTEM_ROUTES } from './app.routes';
import { configsMap, DOMAIN } from '../configurations/defaultConfigs';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SpinnerInterceptor } from './Components/spinner/spinner.interceptor';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export let CURRENT_NAVBAR: INavBar[] = [];
export let CURRENT_SYSTEM_LOGOS: string[] = [];
export let WRONG_SUBDOMAIN: boolean = false;

const getRoutes = () => {
  CURRENT_NAVBAR = configsMap[DOMAIN].navbar;
  CURRENT_SYSTEM_LOGOS = configsMap[DOMAIN].systemLogos;
  return SYSTEM_ROUTES;
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      getRoutes(),
      withEnabledBlockingInitialNavigation(),
      withInMemoryScrolling({
        anchorScrolling: 'disabled',
        scrollPositionRestoration: 'disabled',
      }),
    ),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
    importProvidersFrom(HttpClientModule),
    importProvidersFrom(BrowserAnimationsModule),
    importProvidersFrom(CarouselModule),
    provideAnimationsAsync(),
  ],
};
